import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import DashboardSidebarMenu from "../../components/controls/DashboardSideBarMenu";
import { getProviderMenus } from "../../contexts/ProviderMenus";
import { useAuth } from "../../contexts/AuthContext";

import {
  CheckCircleIcon,
  XCircleIcon,
  ClockIcon,
} from "@heroicons/react/24/solid";

function ProviderDashboard() {
  const { t } = useTranslation();
  const title = t("navbar.provider");
  const menus = getProviderMenus();
  const { currentUser } = useAuth();
  const userId = currentUser?.id;

  // === Status des items (mock, à remplacer par tes appels réels) ===
  const [status, setStatus] = useState({
    hasCompany: false,
    hasCarrier: false,
    hasProducts: false,
    hasInventory: false,
  });

  useEffect(() => {
    async function loadStatus() {
      const hasCompany = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/Provider/companies/${userId}/any`
      ).then((r) => r.json());
      const hasCarrier = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/Provider/carrierAccounts/${userId}/any`
      ).then((r) => r.json());
      const hasProducts = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/Provider/products/${userId}/any`
      ).then((r) => r.json());
      const hasInventory = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/Provider/inventory/${userId}/any`
      ).then((r) => r.json());
      const hasWarehouse = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/Provider/warehouses/${userId}/any`
      ).then((r) => r.json());

      setStatus({
        hasCompany,
        hasCarrier,
        hasProducts,
        hasInventory,
        hasWarehouse,
      });
    }

    loadStatus();
  }, []);

  const checklistItems = [
    {
      label: t("providers.todo.createCompany"),
      done: status.hasCompany,
      action: () => (window.location.href = "/mon-compte/compagnies"),
    },
    {
      label: t("providers.todo.configureCarrier"),
      done: status.hasCarrier,
      action: () => (window.location.href = "/fournisseur-gestion-expedition"),
    },
    {
      label: t("providers.todo.configureWarehouse"),
      done: status.hasWarehouse,
      action: () =>
        (window.location.href = "/fournisseur-gestion-expedition/entrepots"),
    },
    {
      label: t("providers.todo.createProducts"),
      done: status.hasProducts,
      action: () => (window.location.href = "/provider-dashboard-product-list"),
    },
    {
      label: t("providers.todo.manageInventory"),
      done: status.hasInventory,
      action: () => (window.location.href = "/inventaire"),
    },
  ];

  return (
    <div className="flex text-primary">
      <DashboardSidebarMenu title={title} menus={menus} />

      <div className="flex-1 p-6 text-onWhite">
        {/* Description */}
        <h1 className="text-2xl font-bold mb-6">
          {t("providers.dashboardDescription")}
        </h1>

        {/* Checklist Card */}
        <div className="bg-white/10 rounded-xl shadow p-6 max-w-xl shadow-lg">
          <h2 className="text-xl font-semibold mb-4">
            {t("providers.todo.title")}
          </h2>

          <p className="text-sm mb-4 ">{t("providers.todo.subtitle")}</p>

          <ul className="space-y-4">
            {checklistItems.map((item, index) => (
              <li
                key={index}
                className="flex items-center gap-3 cursor-pointer hover:bg-white/10 p-2 rounded-lg transition"
                onClick={item.action}
              >
                {/* Icon */}
                {item.done ? (
                  <CheckCircleIcon className="w-6 h-6 text-green-500" />
                ) : (
                  <XCircleIcon className="w-6 h-6 text-red-500" />
                )}

                {/* Label */}
                <span className="text-primary/80 text-base">{item.label}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default ProviderDashboard;
